import type { Category, Drama, Faq } from "@/types/drama";

export const dramas: Drama[] = [
  {
    id: "chang-ye-jiang-ming",
    title: "长夜将明",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%20of%20a%20lone%20male%20detective%20in%20a%20dark%20trench%20coat%20standing%20in%20heavy%20rain%2C%20warm%20amber%20streetlight%20rim%20light%2C%20deep%20ink%20black%20textured%20background%2C%20moody%20crime%20thriller%20atmosphere%2C%20subtle%20film%20grain%2C%20dramatic%20side%20lighting%2C%20empty%20negative%20space%20near%20the%20bottom%2C%20no%20text&width=600&height=900&seq=poster-changye-01&orientation=portrait",
    year: 2025,
    region: "中国大陆",
    types: ["悬疑", "犯罪", "都市"],
    episodeCount: 38,
    duration: "45分钟",
    director: "沈砚",
    cast: ["陆行舟", "温知夏", "韩森"],
    rating: 9.2,
    heat: 9860,
    status: "更新至第 30 集",
    tagline: "十二年悬案重启，真相藏在每个说谎的人眼里。",
    synopsis:
      "一桩沉寂十二年的灯塔旧案，因为一段匿名录音重新被翻开。刑警队长顾之城回到故乡南川，与当年唯一的目击者、如今的档案修复师沈知夏再度联手，在持续整月的暴雨里追查那个从未被确认的第七个人。",
    analysis:
      "《长夜将明》把推理的重心从“谁做的”转向“为什么所有人都在替同一件事说谎”。剧本采用双时间线交叉剪辑，2013 年的雨夜与当下的调查互相咬合，每一次闪回都比上一次多出几秒画面，观众被迫和主角一起修正记忆。摄影上大量使用湿冷的路灯与逆光剪影，把南川拍成一座永远挂满水汽的证物室。最值得玩味的是沈知夏这个角色：她既是证人，也是共谋，她的每一次沉默都在替观众推迟理解真相的时间。",
    characters: [
      {
        name: "顾之城",
        actor: "陆行舟",
        role: "南川刑侦支队队长",
        desc: "十二年前那场雨夜里最年轻的实习警员，如今带着一份被驳回三次的复查申请回到原点。他把愧疚活成了习惯，也因此比任何人都更懂说谎的人会露出什么样的破绽。",
      },
      {
        name: "沈知夏",
        actor: "温知夏",
        role: "市档案馆修复师",
        desc: "当年唯一的目击者，擅长让褪色的纸张重新显影。她记得所有细节，唯独对那晚最后十分钟保持沉默，这段空白正是全剧的引信。",
      },
      {
        name: "韩森",
        actor: "韩森",
        role: "调查记者",
        desc: "为了追踪旧案可以连续一周睡在车里，看似最不守规矩的搅局者，实际是唯一敢把真相完整写下来的人。",
      },
    ],
    chapters: [
      { index: 1, title: "雨夜的第七个人", summary: "匿名录音寄到市局，十二年前的证词出现第一处矛盾，顾之城决定重启复查。" },
      { index: 2, title: "褪色的值班表", summary: "沈知夏在修复旧档案时发现值班表被替换过，那晚本不该有人在灯塔值班。" },
      { index: 3, title: "沉默的第九分钟", summary: "目击者回忆出现九分钟空白，顾之城在雨里重走当年的路线。" },
      { index: 4, title: "所有灯都亮着", summary: "南川停电，只有灯塔的灯亮着，有人在替过去打信号。" },
      { index: 5, title: "证物室的回声", summary: "被归档的雨伞重新出现，伞骨上的一行编号指向十二年前的另一桩案子。" },
    ],
  },
  {
    id: "jin-xiu-chun-qiu",
    title: "锦绣春秋",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%20of%20a%20Chinese%20ancient%20palace%20courtyard%20at%20dusk%2C%20layered%20red%20silk%20and%20embroidered%20robe%20detail%2C%20warm%20brass%20lanterns%20glowing%2C%20deep%20charcoal%20background%2C%20elegant%20historical%20drama%20atmosphere%2C%20textured%20film%20grain%2C%20refined%20editorial%20lighting%2C%20no%20text&width=600&height=900&seq=poster-jinxiu-02&orientation=portrait",
    year: 2024,
    region: "中国大陆",
    types: ["古装", "爱情", "家庭"],
    episodeCount: 52,
    duration: "42分钟",
    director: "柳明章",
    cast: ["叶知微", "裴砚舟", "苏芷"],
    rating: 8.7,
    heat: 9420,
    status: "全 52 集",
    tagline: "亡国公主以绣娘身份入宫，一针一线缝回自己的名字。",
    synopsis:
      "旧国覆灭那夜，锦绣坊的小主人姜绮被一张绣样救下。七年后她以绣娘身份入宫，替尚衣局修补一件与亡国有关的礼服，却发现每一道针脚里都藏着当年那场大火的时间顺序。",
    analysis:
      "这是一部把权谋安放在指尖上的古装剧。服化道并不追求浮夸的金线堆叠，而是用绣法本身构建叙事：同一只鹤的三种绣法，代表三派人各自说出的历史版本。剧本最聪明的地方在于，女主从未真正握有兵权，她的武器是“记录权”——谁掌握织物上的纹样，谁就掌握了被官方认定的过去。",
    characters: [
      {
        name: "姜绮",
        actor: "叶知微",
        role: "尚衣局绣娘",
        desc: "亡国公主，用七年时间把自己练成一双不会抖的手。她安静、克制，却把复仇写进每一件礼服的下摆。",
      },
      {
        name: "裴砚舟",
        actor: "裴砚舟",
        role: "掌礼司少卿",
        desc: "负责审核礼制的年轻官员，一个把规矩背得滚瓜烂熟的理想主义者，最先发现礼服上不合制的纹样。",
      },
      {
        name: "苏芷",
        actor: "苏芷",
        role: "尚衣局掌事",
        desc: "表面严苛的掌事，实则守着一段无人知晓的旧约，她替姜绮挡下的每一次责罚都另有原因。",
      },
    ],
    chapters: [
      { index: 1, title: "一件旧礼服", summary: "姜绮入宫第一日，就被派去修补那件被封存七年的礼服。" },
      { index: 2, title: "不合制的鹤纹", summary: "裴砚舟在纹样里发现一处逾越礼制的细节，追查却一路指向自己父亲。" },
      { index: 3, title: "三更灯火", summary: "尚衣局失火，唯一被烧掉的偏偏是最不起眼的绣样匣。" },
      { index: 4, title: "绣线里的名字", summary: "拆开下摆的暗线，姜绮看见自己真正的姓氏。" },
      { index: 5, title: "春秋自有笔", summary: "朝堂要一个说法，姜绮选择把礼服当庭展示。" },
    ],
  },
  {
    id: "cheng-nan-jiu-shi-1998",
    title: "城南旧事1998",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%20of%20an%20old%20Chinese%20neighborhood%20alley%20in%20the%201990s%2C%20bicycles%20leaning%20on%20brick%20walls%2C%20warm%20sunset%20light%20through%20laundry%20lines%2C%20nostalgic%20amber%20tones%2C%20deep%20shadow%20background%2C%20documentary%20film%20grain%2C%20no%20text&width=600&height=900&seq=poster-chengnan-03&orientation=portrait",
    year: 2024,
    region: "中国大陆",
    types: ["年代", "家庭", "都市"],
    episodeCount: 36,
    duration: "47分钟",
    director: "周维安",
    cast: ["陈砚生", "林素云", "小小"],
    rating: 9.0,
    heat: 9210,
    status: "全 36 集",
    tagline: "一条巷子要拆了，三代人才第一次坐下来把话说完。",
    synopsis:
      "1998 年夏天，城南柳叶巷贴出第一张拆迁公告。修鞋匠陈砚生在巷口守了三十年，儿子想买新房，孙女想留下那面写满身高刻线的墙。一整个夏天，这条巷子里的人用各自的方式，和住了半辈子的地方告别。",
    analysis:
      "剧集没有把拆迁写成简单的时代赞歌或挽歌，而是让它成为一场关于“记忆归属权”的家庭会议。大量固定长镜头保留巷子的完整空间关系，观众能记住每一扇门通向谁家。台词里几乎没有大词，所有情绪都藏在生活细节里：一碗放凉的绿豆汤、一辆修了三次的自行车、墙上一道长高的刻线。",
    characters: [
      {
        name: "陈砚生",
        actor: "陈砚生",
        role: "修鞋匠",
        desc: "巷口的定海神针，谁家有事都找他。他拒绝搬走，不是因为房子，而是因为鞋摊是他与妻子唯一的共同记忆。",
      },
      {
        name: "林素云",
        actor: "林素云",
        role: "街道办干事",
        desc: "每天夹在居民和文件之间，一边磨破嘴皮讲政策，一边悄悄替老人争取多留一个月。",
      },
      {
        name: "陈小满",
        actor: "小小",
        role: "高中生",
        desc: "陈砚生的孙女，用一台借来的相机拍下整条巷子，她说要留一份“可以带走的城南”。",
      },
    ],
    chapters: [
      { index: 1, title: "第一张贴在墙上的公告", summary: "拆迁办的人来了，柳叶巷的夏天从这里开始变得很吵。" },
      { index: 2, title: "一碗放凉的绿豆汤", summary: "父子俩为签字吵翻，母亲把汤端上桌，谁都没动筷子。" },
      { index: 3, title: "墙上的刻线", summary: "小满发现墙上最早的刻线来自 1978 年，那年她奶奶刚搬进来。" },
      { index: 4, title: "最后一次出摊", summary: "陈砚生把鞋摊擦得干干净净，然后给整条巷子的人免费修鞋。" },
      { index: 5, title: "搬空的院子", summary: "推土机进场那天，所有人都回来了，谁也没说话。" },
    ],
  },
  {
    id: "ni-shi-wo-de-yi-wai",
    title: "你是我的意外",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%20of%20a%20young%20female%20doctor%20in%20a%20light%20coat%20holding%20a%20paper%20cup%20in%20a%20quiet%20hospital%20corridor%20at%20night%2C%20soft%20warm%20lamp%20glow%2C%20blurred%20dark%20background%2C%20gentle%20romantic%20mood%2C%20fine%20film%20grain%2C%20editorial%20portrait%20lighting%2C%20no%20text&width=600&height=900&seq=poster-yiwai-04&orientation=portrait",
    year: 2025,
    region: "中国大陆",
    types: ["都市", "爱情", "治愈"],
    episodeCount: 32,
    duration: "40分钟",
    director: "许南",
    cast: ["沈星禾", "顾言川", "唐棠"],
    rating: 8.2,
    heat: 8740,
    status: "更新至第 24 集",
    tagline: "两个都不相信巧合的人，被同一个夜班反复安排。",
    synopsis:
      "急诊科医生沈星禾习惯把一切写进排班表，独立纪录片导演顾言川则相信所有意外都值得被拍下来。一场暴雨夜的车祸让两人在同一间抢救室外等了六个小时，此后他们开始频繁在城市的各个深夜相遇。",
    analysis:
      "作为一部都市爱情剧，它的甜并不来自巧合本身，而来自两个人对生活的处理方式。剧本用大量工作场景替代告白，把心动藏在交接班的一句“你今天吃饭了吗”。配角线也不敷衍：护士长与丈夫的长期异地、实习生对职业意义的追问，都让主角的感情有了现实参照。",
    characters: [
      {
        name: "沈星禾",
        actor: "沈星禾",
        role: "急诊科主治医师",
        desc: "把情绪折叠得很整齐的人，能在三秒内判断病情，却无法判断自己要不要接受一顿深夜的馄饨。",
      },
      {
        name: "顾言川",
        actor: "顾言川",
        role: "纪录片导演",
        desc: "总在拍别人的故事，因为不太会讲自己的。随身带两台相机，一台拍工作，一台只拍她。",
      },
      {
        name: "唐棠",
        actor: "唐棠",
        role: "急诊科护士长",
        desc: "科室里的定音鼓，嘴上从不饶人，却是最早看出沈星禾心动的人。",
      },
    ],
    chapters: [
      { index: 1, title: "暴雨夜的六个小时", summary: "一台手术、一场车祸、一条借来的充电线，两个人第一次说话。" },
      { index: 2, title: "你也在值夜班", summary: "连续三周在同一家便利店遇见，顾言川开始怀疑这座城市很小。" },
      { index: 3, title: "镜头之外", summary: "沈星禾发现自己被拍进了纪录片，第一次要求他删掉素材。" },
      { index: 4, title: "排班表上的空格", summary: "她第一次在排班表上写下一个不是工作的安排。" },
      { index: 5, title: "意外的定义", summary: "顾言川要离开这座城市三个月，两个人都没有说出挽留。" },
    ],
  },
  {
    id: "wu-jian-zhi-cheng",
    title: "雾间之城",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%20of%20a%20foggy%20harbor%20town%20swallowed%20by%20thick%20sea%20mist%2C%20a%20single%20silhouette%20walking%20along%20a%20wet%20pier%2C%20cold%20grey%20fog%20with%20warm%20amber%20lamp%20accents%2C%20dark%20moody%20mystery%20atmosphere%2C%20subtle%20film%20grain%2C%20no%20text&width=600&height=900&seq=poster-wujian-05&orientation=portrait",
    year: 2025,
    region: "韩国",
    types: ["悬疑", "科幻", "冒险"],
    episodeCount: 16,
    duration: "62分钟",
    director: "朴度贤",
    cast: ["李瑞河道", "尹夏琳", "郑在民"],
    rating: 8.9,
    heat: 9150,
    status: "全 16 集",
    tagline: "海雾封城的第七天，居民开始梦见同一片没有出口的岸。",
    synopsis:
      "港口小城连续七年在同一周被浓雾封锁。气象观测员尹夏琳发现雾的移动并不符合任何已知模型，而每当雾起，城里就会多出一间没人记得何时建好的房子。",
    analysis:
      "一部把科幻设定压在日常生活之下的悬疑剧。它不急于解释机制，而是先让人物在重复的一周里暴露习惯：谁总在同一时间买同一份早餐，谁在雾里开始忘记女儿的名字。雾既是物理现象，也是集体记忆的边界。结尾留下的开放式处理，让整部剧更接近一则关于“选择记住什么”的寓言。",
    characters: [
      {
        name: "尹夏琳",
        actor: "尹夏琳",
        role: "气象观测员",
        desc: "相信数据的人，在连续七年的异常记录里发现自己的笔迹出现在从未写过的页面上。",
      },
      {
        name: "李河道",
        actor: "李瑞河道",
        role: "港口警备队队长",
        desc: "雾天唯一还愿意出勤的人。他坚持记录每一次失踪，哪怕档案总在第二天消失。",
      },
      {
        name: "郑在民",
        actor: "郑在民",
        role: "旧书店老板",
        desc: "掌握着整座城最完整的报纸合订本，也是唯一记得那间多出来的房子原本是什么的人。",
      },
    ],
    chapters: [
      { index: 1, title: "第七年的雾", summary: "雾提前两天到来，观测站的模型第一次完全失效。" },
      { index: 2, title: "多出来的房子", summary: "港区 3 号街出现一栋无人认领的两层建筑，屋内桌上有四副碗筷。" },
      { index: 3, title: "重复的周二", summary: "夏琳发现自己的记录本里多了一页陌生的字迹，日期是明天。" },
      { index: 4, title: "写在雾里的名字", summary: "警备队的失踪名单越来越长，最后一个名字是她自己。" },
      { index: 5, title: "岸的尽头", summary: "两人驾船驶入雾心，试图找到那条从未出现在海图上的岸线。" },
    ],
  },
  {
    id: "shao-nian-bu-ju",
    title: "少年不惧",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%20of%20a%20teenage%20student%20with%20a%20backpack%20standing%20on%20a%20school%20rooftop%20at%20golden%20hour%2C%20warm%20sunlight%20flare%2C%20blurred%20campus%20background%20in%20deep%20shadow%2C%20nostalgic%20youth%20drama%20mood%2C%20film%20grain%2C%20editorial%20photography%2C%20no%20text&width=600&height=900&seq=poster-shaonian-06&orientation=portrait",
    year: 2024,
    region: "中国大陆",
    types: ["青春", "都市", "治愈"],
    episodeCount: 24,
    duration: "38分钟",
    director: "何知远",
    cast: ["夏一舟", "柳青禾", "周叙"],
    rating: 8.4,
    heat: 8320,
    status: "全 24 集",
    tagline: "复读班的最后一百天，他们把失败重新写了一遍。",
    synopsis:
      "第五次月考后，复读班来了一个新班主任。她做的第一件事，是把教室后墙的倒计时撕掉，换成一张空白的纸，让每个人写下自己真正想考的学校和理由。",
    analysis:
      "这部剧难得地把镜头对准“复读”这个很少被正面书写的阶段。它不回避排名的残酷，也没有把努力拍成热血蒙太奇，而是耐心记录那些看似无效的夜晚。最动人的部分是同学之间的相互托举：他们并不总能考上，但学会了在别人失败时递上一瓶水。",
    characters: [
      {
        name: "夏一舟",
        actor: "夏一舟",
        role: "复读班学生",
        desc: "去年差 8 分，今年把志愿表折成纸飞机又捡回来。他擅长解题，不擅长承认自己害怕。",
      },
      {
        name: "柳青禾",
        actor: "柳青禾",
        role: "班主任",
        desc: "第一次带复读班，拒绝用恐惧驱动学生。她办公室的灯总是最后熄，桌上摆着一摞没批完的周记。",
      },
      {
        name: "周叙",
        actor: "周叙",
        role: "同桌",
        desc: "班里唯一不参加排名的人，画画极好。他让所有人明白，人生的答案不止一种写法。",
      },
    ],
    chapters: [
      { index: 1, title: "撕掉倒计时", summary: "新班主任进班第一天，把后墙的数字全部清空。" },
      { index: 2, title: "第八名的位置", summary: "夏一舟月考冲到第八，却第一次在自习课上哭了出来。" },
      { index: 3, title: "空白的志愿表", summary: "周叙拒绝填志愿，被叫去办公室谈了整整两小时。" },
      { index: 4, title: "最后一次晚自习", summary: "教室里没人说话，只有翻页的声音和窗外的蝉。" },
      { index: 5, title: "成绩出来那天", summary: "有人考上，有人没考上，他们还是约好一起吃了顿饭。" },
    ],
  },
  {
    id: "qian-ye-zhi-yan",
    title: "千夜之宴",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%20of%20an%20ornate%20ancient%20banquet%20hall%20with%20hanging%20silk%20lanterns%20and%20a%20long%20empty%20table%2C%20warm%20golden%20candlelight%2C%20deep%20dark%20red%20shadows%2C%20mysterious%20fantasy%20atmosphere%2C%20fine%20film%20grain%2C%20no%20text&width=600&height=900&seq=poster-qianye-07&orientation=portrait",
    year: 2023,
    region: "中国大陆",
    types: ["古装", "奇幻", "悬疑"],
    episodeCount: 40,
    duration: "44分钟",
    director: "白砚之",
    cast: ["宋亦真", "裴照", "云娘"],
    rating: 8.6,
    heat: 7980,
    status: "全 40 集",
    tagline: "每到子时，宴席重置，只有一个人记得所有宾客的死法。",
    synopsis:
      "边城酒楼每到子时会自动重开一席，座上客皆不记得昨日。掌柜宋亦真是唯一保留记忆的人，她用一千个夜晚，试着救下同一个不该死的人。",
    analysis:
      "结构上它接近一部古装悬疑的“时间循环”实验：每一集都是同一场宴的变体，人物的选择稍有不同，结局便完全改写。剧集的美术极为克制，同一张长桌在不同夜里被摆出不同的座次，座次即是权力关系。它真正讨论的是执念——当你有无限次重来的机会，你还愿意为一个人改多少次？",
    characters: [
      {
        name: "宋亦真",
        actor: "宋亦真",
        role: "酒楼掌柜",
        desc: "记住了所有版本的一千个夜晚，也因此最疲惫。她说话极慢，因为她早已知道每句话的后果。",
      },
      {
        name: "裴照",
        actor: "裴照",
        role: "过路剑客",
        desc: "每一夜都会死在同一张桌旁，却每一夜都依然愿意举杯。他不知道自己被记住了多少次。",
      },
      {
        name: "云娘",
        actor: "云娘",
        role: "掌灯人",
        desc: "负责点亮宴席的九十九盏灯，也是唯一隐约察觉时间在重复的人。",
      },
    ],
    chapters: [
      { index: 1, title: "第一夜", summary: "酒楼在子时自动开门，掌柜数着进来的第七个客人。" },
      { index: 2, title: "第九十九盏灯", summary: "云娘少点了一盏灯，宴席上第一次有人活到了天亮。" },
      { index: 3, title: "换一个座次", summary: "宋亦真试着改动座位，整场宴的结局随之偏移。" },
      { index: 4, title: "被记住的人", summary: "裴照在梦里说出了上一夜才发生过的事。" },
      { index: 5, title: "最后一夜", summary: "第一千个夜晚，宋亦真决定不再点亮任何一盏灯。" },
    ],
  },
  {
    id: "shen-hai-you-guang",
    title: "深海有光",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%20of%20a%20deep%20sea%20diver%20silhouette%20suspended%20in%20dark%20water%20with%20a%20single%20warm%20light%20beam%20cutting%20through%2C%20tiny%20bubbles%20and%20particles%2C%20deep%20ink%20water%20background%2C%20adventure%20mystery%20mood%2C%20cinematic%20film%20grain%2C%20no%20text&width=600&height=900&seq=poster-shenhai-08&orientation=portrait",
    year: 2025,
    region: "中国香港",
    types: ["悬疑", "冒险", "犯罪"],
    episodeCount: 20,
    duration: "46分钟",
    director: "麦子谦",
    cast: ["程炜", "何嘉澄", "陈启明"],
    rating: 8.5,
    heat: 8610,
    status: "更新至第 18 集",
    tagline: "打捞队在水下四十米找到一扇不该存在的门。",
    synopsis:
      "一支民间潜水打捞队接到一单奇怪的委托：在维多利亚港外四十米的海底，打捞一只没有任何登记信息的金属箱。队长程炜下水后，却在探照灯里看见一扇带把手的门。",
    analysis:
      "港味十足的悬疑冒险剧，海水与霓虹构成它全部的色彩。剧作对潜水细节的还原相当专业，减压、气瓶、能见度，每一个技术环节都切实推动情节。它的悬念不是“门后面有什么”，而是“谁愿意花三十年让所有人都找不到它”。",
    characters: [
      {
        name: "程炜",
        actor: "程炜",
        role: "打捞队队长",
        desc: "下过两千次水，从不相信海里有超自然的东西。直到他在水下听见有人敲了三下门。",
      },
      {
        name: "何嘉澄",
        actor: "何嘉澄",
        role: "海洋档案研究员",
        desc: "从旧海图里找出那片海域的历史，她带来的是整部剧最关键的一块拼图。",
      },
      {
        name: "陈启明",
        actor: "陈启明",
        role: "船东",
        desc: "委托的出资人，说话永远留半句，他真正想打捞的显然不是那只箱子。",
      },
    ],
    chapters: [
      { index: 1, title: "四十米下的门", summary: "一次常规打捞，探照灯照出了不该出现在海床上的东西。" },
      { index: 2, title: "没有登记的箱子", summary: "委托文件上的编号在海关系统里查无此人。" },
      { index: 3, title: "旧海图", summary: "何嘉澄在 1974 年的海图上发现这片海域曾被整个涂黑。" },
      { index: 4, title: "三下敲门声", summary: "水下录音里出现规律的敲击，节奏是摩尔斯电码。" },
      { index: 5, title: "上浮之前", summary: "气瓶报警，程炜必须决定带箱子还是带证据上水面。" },
    ],
  },
  {
    id: "gui-lai-de-chun-tian",
    title: "归来的春天",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%20of%20an%20older%20woman%20sitting%20by%20a%20bright%20window%20in%20a%20warm%20family%20living%20room%2C%20soft%20afternoon%20light%2C%20gentle%20dust%20particles%20in%20the%20air%2C%20tender%20emotional%20mood%2C%20muted%20warm%20tones%2C%20editorial%20film%20grain%2C%20no%20text&width=600&height=900&seq=poster-guilai-09&orientation=portrait",
    year: 2024,
    region: "中国台湾",
    types: ["家庭", "都市", "治愈"],
    episodeCount: 28,
    duration: "43分钟",
    director: "林见月",
    cast: ["刘美惠", "陈以安", "许丞"],
    rating: 8.8,
    heat: 8050,
    status: "全 28 集",
    tagline: "母亲忘记了所有人，却每天准时煮四碗面。",
    synopsis:
      "一次轻度中风后，母亲失去了近三十年的记忆。三个各自在城市里忙碌的孩子被迫轮流回乡照顾她，而母亲每天傍晚仍会煮四碗面，摆上四副碗筷。",
    analysis:
      "它把“失忆”当作重新认识彼此的入口，而不是制造苦情的工具。剧本最厉害的是不急着和解：兄弟姐妹之间的旧账照样翻，母亲的固执依旧让人崩溃。真正被治愈的不是记忆，而是这家人终于愿意在同一张桌子前，把面吃完再说话。",
    characters: [
      {
        name: "刘美惠",
        actor: "刘美惠",
        role: "母亲",
        desc: "忘了孩子的名字，却记得每个人的口味。她把爱煮进面里，因为语言已经不够用了。",
      },
      {
        name: "陈以安",
        actor: "陈以安",
        role: "长女",
        desc: "习惯了替所有人做决定的人，回乡后发现最难的课题是允许自己求助。",
      },
      {
        name: "许丞",
        actor: "许丞",
        role: "幺子",
        desc: "多年未归的乐队键盘手，带着一箱没写完的歌回来，发现家里的旧钢琴还准。",
      },
    ],
    chapters: [
      { index: 1, title: "四碗面", summary: "母亲出院回家，第一件事是走进厨房煮面。" },
      { index: 2, title: "不认识的名字", summary: "她把长女叫成了邻居的名字，三兄妹第一次沉默地坐在一起。" },
      { index: 3, title: "旧相册", summary: "相册里有一整页被剪掉的照片，没人愿意先开口解释。" },
      { index: 4, title: "钢琴还准", summary: "许丞弹起小时候的曲子，母亲第一次跟着哼了两句。" },
      { index: 5, title: "春天来的时候", summary: "院子里的树开花了，桌上终于只摆三副碗筷。" },
    ],
  },
  {
    id: "di-shi-er-feng-xin",
    title: "第十二封信",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%20of%20a%20rainy%20English%20manor%20corridor%20with%20vintage%20wallpaper%20and%20a%20single%20letter%20on%20a%20wooden%20table%2C%20dim%20warm%20candle%20lamp%2C%20deep%20shadows%2C%20classic%20whodunit%20mystery%20atmosphere%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=poster-shierfeng-10&orientation=portrait",
    year: 2025,
    region: "英国",
    types: ["悬疑", "犯罪", "年代"],
    episodeCount: 8,
    duration: "58分钟",
    director: "艾略特·格兰特",
    cast: ["伊芙·哈洛", "詹姆斯·柯尔", "诺拉·韦恩"],
    rating: 9.1,
    heat: 8890,
    status: "全 8 集",
    tagline: "十一封信都寄对了人，唯独第十二封写着一个还没出生的人名。",
    synopsis:
      "1937 年的英格兰乡间，庄园女主人去世后，管家在书房里发现一叠未寄出的信。十一位收信人全部在三个月内相继离世，第十二封信上的名字，属于庄园里刚出生的婴儿。",
    analysis:
      "一部古典本格气质的迷你剧。八集的体量让每一封信都能被单独展开，成为一集的结构核心。它巧妙地把“信”既当作线索也当作判决书：写信的人以为自己在记录，其实在安排。结局并不依赖意外的凶手，而是揭示一个更冷的事实——这个家族早已习惯用体面的方式处理不体面的事。",
    characters: [
      {
        name: "伊芙·哈洛",
        actor: "伊芙·哈洛",
        role: "女管家",
        desc: "在庄园服务十九年，知道每一把钥匙的用途。她开始怀疑自己也是名单上的某一个人。",
      },
      {
        name: "詹姆斯·柯尔",
        actor: "詹姆斯·柯尔",
        role: "家族律师",
        desc: "负责执行遗嘱的人，也是唯一读完了全部十二封信却选择沉默的人。",
      },
      {
        name: "诺拉·韦恩",
        actor: "诺拉·韦恩",
        role: "婴儿的母亲",
        desc: "她想带着孩子离开庄园，却发现门外那条路的尽头，早就有人在等。",
      },
    ],
    chapters: [
      { index: 1, title: "第一封信", summary: "葬礼之后，书房里出现一叠从未寄出的信。" },
      { index: 2, title: "十一个名字", summary: "哈洛核对名单，发现前十一位都已不在人世。" },
      { index: 3, title: "雨夜来访", summary: "一位自称收信人的陌生人敲开了庄园的门。" },
      { index: 4, title: "婴儿房", summary: "第十二封信被放在婴儿床边，封口是新的。" },
      { index: 5, title: "最后一页", summary: "柯尔终于承认，他十九年前就见过这套信纸。" },
    ],
  },
  {
    id: "xing-chen-da-hai-zhi-wai",
    title: "星辰大海之外",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%20of%20an%20astronaut%20standing%20inside%20a%20dark%20space%20observatory%20dome%2C%20warm%20amber%20instrument%20lights%2C%20dense%20star%20field%20visible%20through%20the%20window%2C%20deep%20black%20background%2C%20quiet%20sci-fi%20atmosphere%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=poster-xingchen-11&orientation=portrait",
    year: 2025,
    region: "美国",
    types: ["科幻", "冒险", "悬疑"],
    episodeCount: 10,
    duration: "55分钟",
    director: "马库斯·里德",
    cast: ["艾登·贝克", "米拉·陈", "奥斯卡·诺兰"],
    rating: 8.3,
    heat: 8460,
    status: "全 10 集",
    tagline: "深空观测站收到一段来自地球的求救信号，时间是三十年后。",
    synopsis:
      "距离地球四光年的观测站上，三名宇航员接收到一段异常信号。解码后他们发现，发送者使用的是本站的内部频道，而发送时间显示为三十年后的地球。",
    analysis:
      "硬科幻外壳下，它其实在问一个非常人性的问题：如果你提前知道结局，你还愿意按下那个按钮吗？剧集对空间站日常的描写极其耐心，用餐、维修、例行体检，这些平静的片段让后来的抉择变得沉重。第三集那段长达六分钟的无声场景，是全剧最好的段落。",
    characters: [
      {
        name: "艾登·贝克",
        actor: "艾登·贝克",
        role: "站长",
        desc: "在轨道上待了九百天的人，最擅长的就是把恐惧整理成待办清单。",
      },
      {
        name: "米拉·陈",
        actor: "米拉·陈",
        role: "通讯工程师",
        desc: "第一个听出信号里藏着女儿声音的人，也是唯一坚持要回复的人。",
      },
      {
        name: "奥斯卡·诺兰",
        actor: "奥斯卡·诺兰",
        role: "医疗官",
        desc: "负责让大家活着回去的人，却在日志里写下了“也许不必回去”。",
      },
    ],
    chapters: [
      { index: 1, title: "异常频段", summary: "例行扫描捕获一段不属于任何已知来源的信号。" },
      { index: 2, title: "三十年后的地球", summary: "时间戳让整个观测站陷入沉默。" },
      { index: 3, title: "六分钟静默", summary: "通讯中断，三个人在各自的舱室里做同一件事：写下要说的话。" },
      { index: 4, title: "是否回复", summary: "回复意味着暴露坐标，不回复意味着放弃唯一的机会。" },
      { index: 5, title: "舷窗之外", summary: "信号源出现在观测站外三百米处，肉眼可见。" },
    ],
  },
  {
    id: "yan-huo-ren-jian",
    title: "烟火人间",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%20of%20a%20night%20food%20street%20with%20steaming%20stalls%20and%20warm%20hanging%20bulbs%2C%20a%20vendor%20smiling%20while%20cooking%2C%20blurred%20crowd%20in%20the%20background%2C%20cozy%20warm%20amber%20tones%20and%20deep%20shadow%2C%20healing%20drama%20mood%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=poster-yanhuo-12&orientation=portrait",
    year: 2025,
    region: "中国大陆",
    types: ["都市", "治愈", "家庭"],
    episodeCount: 30,
    duration: "42分钟",
    director: "程一鸣",
    cast: ["陶然", "米朵", "老赵"],
    rating: 8.9,
    heat: 8360,
    status: "更新至第 26 集",
    tagline: "夜市十一点，每个摊主都有一个不肯收摊的理由。",
    synopsis:
      "城南夜市即将改造，三十七个摊主要在同一份协议上签字。卖糖水的陶然、做烧腊的米朵、修表的老人老赵，在最后一个夏天里，用各自的摊位留住了一些人。",
    analysis:
      "这是一部群像剧，但没有刻意煽情。它相信观众愿意看普通人怎么认真做一件小事：怎么把握火候，怎么记住熟客的口味，怎么在收摊时把地面冲干净。所有关于城市化的讨论，都藏在“要不要再摆一个月”这样的日常问句里。",
    characters: [
      {
        name: "陶然",
        actor: "陶然",
        role: "糖水摊主",
        desc: "三十岁，从写字楼辞职接手外婆的摊位。她记得每个熟客的甜度，却不太会照顾自己。",
      },
      {
        name: "米朵",
        actor: "米朵",
        role: "烧腊师傅",
        desc: "夜市里最早上摊的人，一把刀用得又快又稳。她想把父亲的手艺开成一家店。",
      },
      {
        name: "老赵",
        actor: "老赵",
        role: "修表匠",
        desc: "摊子最小，来的都是几十年的老客。他说表和人一样，不怕旧，就怕没人愿意修。",
      },
    ],
    chapters: [
      { index: 1, title: "最后一个夏天", summary: "改造通知贴上电线杆，夜市第一次集体开了一次会。" },
      { index: 2, title: "熟客的口味", summary: "陶然记住了一位老人每晚都要的甜度，却不知道他等的另有其人。" },
      { index: 3, title: "一把旧刀", summary: "米朵的父亲走进摊位，二十年没碰过刀的手还有些抖。" },
      { index: 4, title: "十一点以后", summary: "收摊之后，摊主们蹲在路边分了一锅卖剩的汤。" },
      { index: 5, title: "灯还亮着", summary: "协议签完的那天晚上，整条街的灯比往常多亮了一小时。" },
    ],
  },
];

export const categories: Category[] = [
  { name: "都市", icon: "ri-building-4-line", desc: "城市生活与职场情感，贴近日常的叙事。", count: 214 },
  { name: "古装", icon: "ri-ancient-pavilion-line", desc: "朝堂权谋、宫廷礼制与古典美学。", count: 186 },
  { name: "悬疑", icon: "ri-spy-line", desc: "层层反转的推理与罪案追查。", count: 152 },
  { name: "青春", icon: "ri-leaf-line", desc: "校园、成长与那些未说出口的话。", count: 98 },
  { name: "年代", icon: "ri-time-line", desc: "时代切片里的人情与家国记忆。", count: 76 },
  { name: "科幻", icon: "ri-planet-line", desc: "近未来设定与思想实验式故事。", count: 64 },
];

export const typeOptions = [
  "都市",
  "古装",
  "悬疑",
  "青春",
  "年代",
  "科幻",
  "爱情",
  "家庭",
  "奇幻",
  "冒险",
  "犯罪",
  "治愈",
];

export const yearOptions = [2025, 2024, 2023, 2022];

export const regionOptions = [
  "中国大陆",
  "中国香港",
  "中国台湾",
  "韩国",
  "日本",
  "美国",
  "英国",
];

export const faqs: Faq[] = [
  {
    question: "网站上的剧集可以完整观看吗？",
    answer:
      "目前站点仅提供剧情介绍、角色分析与剧集目录浏览，详情页中的演示区为前端界面演示，不提供完整剧集播放或下载。",
  },
  {
    question: "剧情介绍与角色分析来自哪里？",
    answer:
      "所有剧集资料、剧情概述与角色分析均由编辑团队整理与撰写的示例内容，用于展示站点的内容结构与阅读体验。",
  },
  {
    question: "收藏的剧集会保存多久？",
    answer:
      "收藏状态保存在你当前浏览器的本地存储中，不会上传服务器。更换设备或清除浏览器数据后，收藏记录将不再保留。",
  },
  {
    question: "可以申请收录新的剧集吗？",
    answer:
      "可以。你可以通过本页下方的反馈表单提交剧名、年份与推荐理由，编辑团队会定期查看并整理。",
  },
];

export const siteStats = [
  { label: "收录剧集", value: "1,286", suffix: "部" },
  { label: "深度解析", value: "962", suffix: "篇" },
  { label: "每日更新", value: "24", suffix: "条" },
  { label: "剧迷评分", value: "4.9", suffix: "分" },
];